module.exports = __webpack_public_path__ + "img/[奸笑].2af842ab.svg";